import { useState, useEffect } from "react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "회사소개", href: "#about" },
    { label: "제공서비스", href: "#services" },
    { label: "진행절차", href: "#process" },
    { label: "시공사례", href: "#portfolio" },
    { label: "FAQ", href: "#faq" },
    { label: "견적요청", href: "#estimate" },
  ];

  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
          scrolled ? "bg-white shadow-md py-2 lg:py-3" : "bg-transparent py-3 lg:py-5"
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 lg:px-6 flex items-center justify-between">
          {/* Logo */}
          <a href="#" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-2 lg:gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/af1a3309-e7cb-4f5c-b986-960b45a850ba.png"
              alt="착한누수 로고"
              className="h-9 lg:h-12 w-auto object-contain rounded-lg"
            />
            <div className="flex flex-col leading-tight">
              <span className={`text-base lg:text-lg font-black tracking-tight ${scrolled ? "text-zinc-900" : "text-white"}`}>착한누수</span>
            </div>
          </a>

          {/* Desktop Nav Links */}
          <ul className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <li key={link.href}>
                <button
                  onClick={() => scrollTo(link.href)}
                  className={`text-sm font-semibold transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-blue-500 ${
                    scrolled ? "text-zinc-700" : "text-white"
                  }`}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>

          {/* Call Button - Desktop */}
          <a
            href="tel:010-2684-4892"
            className="hidden lg:flex items-center gap-2 bg-blue-500 hover:bg-blue-400 text-white font-bold px-5 py-2.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base" />
            </span>
            <span>010-2684-4892</span>
          </a>

          {/* Mobile Hamburger */}
          <button
            className={`lg:hidden w-7 h-7 flex items-center justify-center cursor-pointer ${scrolled ? "text-zinc-800" : "text-white"}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-xl ${menuOpen ? "ri-close-line" : "ri-menu-line"}`} />
          </button>
        </div>

        {/* Mobile Menu */}
        {menuOpen && (
          <div className="lg:hidden bg-white border-t border-zinc-100 px-4 py-3 flex flex-col gap-2">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollTo(link.href)}
                className="text-left text-zinc-700 text-sm font-semibold py-1.5 border-b border-zinc-100 hover:text-blue-500 cursor-pointer"
              >
                {link.label}
              </button>
            ))}
            <a
              href="tel:010-2684-4892"
              className="mt-2 flex items-center justify-center gap-2 bg-blue-500 text-white text-sm font-bold px-4 py-2.5 rounded-full cursor-pointer"
            >
              <i className="ri-phone-fill" />
              <span>010-2684-4892 바로전화</span>
            </a>
          </div>
        )}
      </nav>
    </>
  );
}
